module.exports = require('./lib/marvel-ui-badge.js');